<template>
  <div class="main-panel">
    <div class="products-container-v2">
      <!-- Обновленный Заголовок -->
      <div class="page-header-v2">
        <div>
          <h2 class="page-title-v2">
            <i class="fa fa-box-open me-2"></i>Список виробів
          </h2>
        </div>
        <div class="header-actions">
          <b-button @click="createOrder" variant="primary" v-if="checkedList.length > 0" class="me-2">
            <i class="fa fa-shopping-cart me-1"></i> Створити замовлення
          </b-button>
          <b-button :to="{ name: 'Products-create' }" variant="primary">
            <i class="fa fa-plus me-1"></i> Додати виріб
          </b-button>
        </div>
      </div>

      <!-- Таблица в виде карточки -->
      <div class="card table-card-v2">
        <div class="table-responsive">
          <table class="table orders-table-v2">
            <thead>
              <tr>
                <th class="text-center" style="width: 50px;">
                  <i class="fa fa-check-square"></i>
                </th>
                <th>Назва виробу</th>
                <th>Деталі</th>
                <th class="text-center" style="width: 120px;">Дії</th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr>
                <td colspan="4" class="text-center p-5">
                  <div class="spinner-border text-primary" role="status">
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="products.length === 0">
              <tr>
                <td colspan="4" class="text-center p-5">
                  <div class="empty-state-v2">
                    <i class="fa fa-inbox"></i>
                    <h4>Немає виробів</h4>
                    <p>Створіть свій перший виріб, щоб побачити його тут.</p>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="item in products" :key="item.id">
                <td class="text-center">
                  <b-form-checkbox v-if="item.details.length > 0" :value="item.id"
                    v-model="checkedList"></b-form-checkbox>
                </td>
                <td>{{ item.name }}</td>
                <td>
                  <span class="product-list-v2" :title="getDetailsList(item)">
                    {{ truncateText(getDetailsList(item), 80) }}
                  </span>
                </td>
                <td class="text-center">
                  <div class="btn-group btn-group-sm">
                    <router-link :to="{ name: 'Products-update', params: { id: item.id } }"
                      class="btn btn-outline-primary" title="Редагувати">
                      <i class="fa fa-pen"></i>
                    </router-link>
                    <b-button @click="deleteOrder(item.id)" variant="outline-danger" title="Видалити">
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer" v-if="totalPages > recordsPerPage">
          <b-pagination v-model="currentPage" :total-rows="totalPages" :per-page="recordsPerPage"
            aria-controls="products-table" align="center" size="sm"></b-pagination>
        </div>
      </div>
    </div>
    <order-form-modal @on-submit="sendOrder" @on-close="modalShow = false" :products="checkedProducts"
      :orderData="orderData" :text="textModal" :errorSize="errorSize" :visible="modalShow" />
  </div>
</template>

<script>
import { productService } from "../../services/productService";
import productForm from "./Form.vue"
import orderFormModal from "../Order/OrderModal.vue"
import { orderService } from "../../services/orderService";


export default {
  components: {
    productForm,
    orderFormModal,
  },
  data() {
    return {
      modalShow: false,
      errorSize: false,
      textModal: '',
      loading: false,
      checkedList: [],
      order: {},
      orderData: {},
      products: [],
      currentPage: 1,
      totalPages: 0,
      recordsPerPage: 20,
      params: '',
      modalValid: true,
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.params = `?page=${value}&size=${this.recordsPerPage}`
        this.fetchData()
      }
    }
  },
  computed: {
    checkedProducts() {
      return this.checkedList.map(index => this.products.find(product => product.id == index))
    }
  },
  methods: {
    getDetailsList(item) {
      return item.details.filter(detail => detail.detail_name != null).map(detail => detail.detail_name).join(', ');
    },
    truncateText(text, maxLength) {
      if (!text) return '—';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    createOrder(data = {}) {
      this.order = data;
      this.orderData = this.getOrderObject();
      this.modalShow = true;
      this.validateOrder().then(() => {
        // this.sendOrder(this.orderData);
      }).catch((response) => {
        // this.modalShow = true;
      })
    },
    sendOrder(data, products) {
      this.modalShow = false;
      if (this.errorSize) return;
      let items = [];
      this.checkedList.forEach(index => {
        let item = this.products.find(product => product.id == index);
        item.details.forEach(temp => {
          temp.count = (temp.count || 1) * item.count;
          items.push(temp);
        })

      });
      this.orderData.items = items;
      this.loading = true;
      this.orderData.customer_material = data.customer_material;
      this.orderData.customer_edge = data.customer_edge;
      this.orderData.glue = data.glue;
      orderService.create(this.orderData).then((res) => {
        let orderId = res.order.id;
        this.$router.push({ name: 'order-edit', params: { id: orderId } })
      })
    },
    validateOrder() {
      let customer_material = null, customer_edge = null, glue = null, edge_size = null;
      let errorGlue = false;
      this.errorSize = false;
      let errorMaterial = false;
      let errorEdge = false;
      this.checkedList.forEach(index => {
        let item = this.products.find(product => product.id == index);

        if (glue != null && glue != item.glue) {
          errorGlue = true;
          this.modalValid = false;
        } else {
          glue = item.glue

        }
        if (edge_size != null && edge_size != item.edge_size) {
          this.errorSize = true;
          this.modalValid = false;
        } else {
          edge_size = item.edge_size
        }

        if (customer_material != null && customer_material != item.customer_material) {
          errorMaterial = true;
          this.modalValid = false;
        } else {
          customer_material = item.customer_material;
        }

        if (customer_edge != null && customer_edge != item.customer_edge) {
          errorEdge = true;
          this.modalValid = false;
        } else {
          customer_edge = item.customer_edge
        }
      });

      if (errorGlue || this.errorSize) {
        let text = 'Параметри ';
        if (errorGlue) {
          text += '"Оклеювання клеєм PUR" '
        }
        if (errorGlue && errorSize) {
          text += ' та '
        }
        if (this.errorSize) {
          text += ' "Розмір з Кромкою"'
        }
        text += ' мають бути однакові у всіх виробах. Зробіть зміни';
        return Promise.reject({ type: 'error', message: text });
      } else if (errorEdge || errorMaterial) {
        let text = 'Параметри ';
        if (errorEdge) {
          text += '"Матеріал Клієнта" '
        }
        if (errorMaterial && errorEdge) {
          text += ' та '
        }
        if (errorMaterial) {
          text += ' "Кромка Клієнта"'
        }

        text += ' різні для виробів, в замовлення параметри не будуть передані';
        return Promise.reject({ type: 'notify', message: text });
      }

      return Promise.resolve()


    },
    getOrderObject() {
      let production_params, cli, data, materialsMap = new Map(), edgesMap = new Map(),
        names = [], screeds = [], details = [], screeMax = [],
        glue = true, customer_material = true, customer_edge = true, edge_size = true;
      production_params = this.$store.state.auth.user.client.production_params[0];
      let detailIteration = 0;
      let notCheck = [];

      // Получаем палитры цветов из store или используем дефолтные
      const materialColors = this.$store.getters['data/materialColors'] || [
        '#FF0000', '#FF7F00', '#00FF00', '#00FFFF',
        '#0000FF', '#8B00FF', '#A52A2A', '#FFC0CB', '#808080',
        '#000000', '#008080', '#FFD700', '#4B0082', '#006400',
        '#FF1493', '#00CED1', '#7FFF00', '#DA70D6', '#FF4500'
      ];
      const edgeColors = this.$store.getters['data/edgeColors'] || [
        '#FF0000', '#FF7F00', '#00FF00', '#00FFFF',
        '#0000FF', '#8B00FF', '#A52A2A', '#FFC0CB', '#808080',
        '#000000', '#008080', '#FFD700', '#4B0082', '#006400',
        '#FF1493', '#00CED1', '#7FFF00', '#DA70D6', '#FF4500'
      ];

      // Функция для получения следующего доступного цвета
      const getNextAvailableColor = (usedColors, colorPalette) => {
        for (const color of colorPalette) {
          if (!usedColors.has(color)) {
            return color;
          }
        }
        // Если все цвета использованы, возвращаем первый из палитры
        return colorPalette[0];
      };

      this.checkedList.forEach((index, key) => {
        let item = this.products.find(product => product.id == index);
        item.details.forEach((detail) => {
          screeMax.push(detail.screed);
        })
      });

      let defaultMaterialRef = null;
      let defaultEdgeRef = null;

      this.checkedList.forEach((index, key) => {
        let item = this.products.find(product => product.id == index);
        if (glue) {
          glue = item.glue;
        }
        if (customer_material) {
          customer_material = item.customer_material;
        }
        if (customer_edge) {
          customer_edge = item.customer_edge;
        }
        if (edge_size) {
          edge_size = item.edge_size;
        }
        names.push({ name: item.name, id: item.id })

        let currmax = item.details.map(i => i.screed).reduce((a, b) => Math.max(a, b), -Infinity) + 1;

        item.details.forEach((detail) => {
          details.push(detail)
        });

        // Собираем материалы и кромки из materials_list и edge_list продукта
        if (item.materials_list && Array.isArray(item.materials_list)) {
          item.materials_list.forEach((material) => {
            if (material.ref) {
              // Если материал уже есть, но с другим цветом - это тоже дубль цвета
              if (!materialsMap.has(material.ref)) {
                materialsMap.set(material.ref, {
                  ref: material.ref,
                  color: material.color || '#000000'
                });
                // Устанавливаем дефолтный материал как первый попавшийся
                if (defaultMaterialRef === null) {
                  defaultMaterialRef = material.ref;
                }
              } else {
                // Если ref уже есть, но цвет другой - запоминаем, что будет конфликт цвета
                const existingMaterial = materialsMap.get(material.ref);
                if (existingMaterial.color !== (material.color || '#000000')) {
                  // Цвет будет заменен при обработке дублей
                }
              }
            }
          });
        }

        if (item.edge_list && Array.isArray(item.edge_list)) {
          item.edge_list.forEach((edge) => {
            if (edge.ref) {
              // Если кромка уже есть, но с другим цветом - это тоже дубль цвета
              if (!edgesMap.has(edge.ref)) {
                edgesMap.set(edge.ref, {
                  ref: edge.ref,
                  color: edge.color || '#000000'
                });
                // Устанавливаем дефолтную кромку как первую попавшуюся
                if (defaultEdgeRef === null) {
                  defaultEdgeRef = edge.ref;
                }
              } else {
                // Если ref уже есть, но цвет другой - запоминаем, что будет конфликт цвета
                const existingEdge = edgesMap.get(edge.ref);
                if (existingEdge.color !== (edge.color || '#000000')) {
                  // Цвет будет заменен при обработке дублей
                }
              }
            }
          });
        }

        let clone = [...item.details];

        clone.sort((a, b) => a.screed - b.screed).forEach((detail) => {

          if (detail.edge_l != null) {
            if (!edgesMap.has(detail.edge_l)) {
              edgesMap.set(detail.edge_l, {
                ref: detail.edge_l,
                color: '#000000'
              });
              if (defaultEdgeRef === null) {
                defaultEdgeRef = detail.edge_l;
              }
            }
          }
          if (detail.edge_b != null) {
            if (!edgesMap.has(detail.edge_b)) {
              edgesMap.set(detail.edge_b, {
                ref: detail.edge_b,
                color: '#000000'
              });
              if (defaultEdgeRef === null) {
                defaultEdgeRef = detail.edge_b;
              }
            }
          }

          if (detail.edge_t != null) {
            if (!edgesMap.has(detail.edge_t)) {
              edgesMap.set(detail.edge_t, {
                ref: detail.edge_t,
                color: '#000000'
              });
              if (defaultEdgeRef === null) {
                defaultEdgeRef = detail.edge_t;
              }
            }
          }
          if (detail.edge_r != null) {
            if (!edgesMap.has(detail.edge_r)) {
              edgesMap.set(detail.edge_r, {
                ref: detail.edge_r,
                color: '#000000'
              });
              if (defaultEdgeRef === null) {
                defaultEdgeRef = detail.edge_r;
              }
            }
          }

          if (detail.edge_template != null) {
            if (!edgesMap.has(detail.edge_template)) {
              edgesMap.set(detail.edge_template, {
                ref: detail.edge_template,
                color: '#000000'
              });
              if (defaultEdgeRef === null) {
                defaultEdgeRef = detail.edge_template;
              }
            }
          }

          if (detail.material != null) {
            if (!materialsMap.has(detail.material)) {
              materialsMap.set(detail.material, {
                ref: detail.material,
                color: '#000000'
              });
              if (defaultMaterialRef === null) {
                defaultMaterialRef = detail.material;
              }
            }
          }

          if (detail.screed != null && [0, 1].indexOf(detail.screed) === -1) {
            if (screeds.filter(scr => scr.No === detail.screed).length === 0) {
              screeds.push({ No: detail.screed });
              item.details.forEach((ttt, index) => {
                if (ttt.screed === detail.screed) {
                  notCheck.push(ttt.id)
                }
              })
            } else if (detailIteration !== key &&
              notCheck.indexOf(detail.id) === -1 &&
              screeds.filter(scr => scr.No === detail.screed).length !== 0) {

              let max = screeds.map(i => i.No).reduce((a, b) => Math.max(a, b), -Infinity) + 1;

              if (max < currmax) {
                max = currmax;
              }

              let currentScreed = detail.screed;
              screeds.push({ No: max });
              screeMax.push(max);
              item.details.forEach((ttt, index) => {
                if (ttt.screed === currentScreed) {
                  item.details[index].screed = max;
                  notCheck.push(ttt.id)
                }
              })

            }
          }

        });
        detailIteration = key;

      })
      let firstItem = screeds.map(i => i.No).indexOf(1);
      if (firstItem !== -1) {
        screeds.splice(firstItem, 1);
      }

      // Обработка дублей цветов для материалов
      const usedMaterialColors = new Set();

      // Собираем все используемые ref'ы материалов и кромок из деталей
      const usedMaterialRefs = new Set();
      const usedEdgeRefs = new Set();

      details.forEach((detail) => {
        if (detail.material) {
          usedMaterialRefs.add(detail.material);
        }
        if (detail.edge_l) usedEdgeRefs.add(detail.edge_l);
        if (detail.edge_b) usedEdgeRefs.add(detail.edge_b);
        if (detail.edge_t) usedEdgeRefs.add(detail.edge_t);
        if (detail.edge_r) usedEdgeRefs.add(detail.edge_r);
        if (detail.edge_template) usedEdgeRefs.add(detail.edge_template);
      });

      // Фильтруем материалы, оставляя только используемые в деталях
      const filteredMaterials = Array.from(materialsMap.values())
        .filter(material => usedMaterialRefs.has(material.ref));

      // Обновляем дефолтный материал, если текущий не используется
      if (defaultMaterialRef && !usedMaterialRefs.has(defaultMaterialRef)) {
        defaultMaterialRef = filteredMaterials.length > 0 ? filteredMaterials[0].ref : null;
      }

      const materialsList = filteredMaterials.map((material) => {
        let color = material.color || '#000000';

        // Если цвет уже используется, получаем следующий доступный
        if (usedMaterialColors.has(color)) {
          color = getNextAvailableColor(usedMaterialColors, materialColors);
        }

        usedMaterialColors.add(color);

        return {
          ref: material.ref,
          color: color,
          default: material.ref === defaultMaterialRef
        };
      });

      // Обработка дублей цветов для кромок
      const usedEdgeColors = new Set();

      // Фильтруем кромки, оставляя только используемые в деталях
      const filteredEdges = Array.from(edgesMap.values())
        .filter(edge => usedEdgeRefs.has(edge.ref));

      // Обновляем дефолтную кромку, если текущая не используется
      if (defaultEdgeRef && !usedEdgeRefs.has(defaultEdgeRef)) {
        defaultEdgeRef = filteredEdges.length > 0 ? filteredEdges[0].ref : null;
      }

      const edgesList = filteredEdges.map((edge) => {
        let color = edge.color || '#000000';

        // Если цвет уже используется, получаем следующий доступный
        if (usedEdgeColors.has(color)) {
          color = getNextAvailableColor(usedEdgeColors, edgeColors);
        }

        usedEdgeColors.add(color);

        return {
          ref: edge.ref,
          color: color,
          default: edge.ref === defaultEdgeRef
        };
      });

      cli = {
        "dept": "ТПМ",
        "not_show": true,
        "section": production_params.section,
        "customer": this.$store.state.auth.user.client.ref,
        "stock": this.$store.state.auth.user.defaultStock,
        "cy": "980",//980
        "manager": production_params.manager,
        "price_type": production_params.price_type,
        "draw_cut": false,
        "to_work": false,
        "check_parts": false,
        "materials_list": materialsList,
        "edge_list": edgesList,
        "screed_list": screeds,
        "name_list": names,
        "glue": glue,
        "customer_material": customer_material,
        "customer_edge": customer_edge,
        "edge_size": edge_size,
      };
      this.order.items = details;
      data = {
        ...this.order,
        ...cli,
      };

      return data;
    },
    deleteOrder(id) {
      this.$bvModal.msgBoxConfirm('Ви впевнені, що хочете видалити виріб?', {
        title: 'Підтвердіть',
        size: 'mm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Так',
        cancelTitle: 'Ні',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then((value) => {
          if (value) {
            this.loading = true;
            productService.deleteProduct(id).then(response => {
              this.$toast.success("Успішно видалено");
              this.fetchData();
            }).then(r => {
            }).catch(e => {
              this.loading = false;
              this.$toast.error("Щось пішло не так =(");
            });
          }
        })
    },
    fetchData() {
      this.loading = true;
      productService.getListProducts(this.params).then((response) => {
        if (response.data) {
          this.products = response.data
          this.totalPages = response.meta.total
          this.loading = false
        }
      });
    }
  },
  name: "product-list"
}
</script>

<style scoped>
.products-container-v2 {
  max-width: 1600px;
  margin: 20px auto;
  padding: 0;
}

.page-header-v2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #dee2e6;
}

.page-title-v2 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #343a40;
  margin: 0;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.page-subtitle-v2 {
  font-size: 0.9rem;
  color: #2c5aa0;
  margin-top: 0.25rem;
}

.header-actions {
  display: flex;
  gap: 1rem;
}

.header-actions .btn {
  padding: 0.6rem 1.2rem;
  font-size: 0.9rem;

}

.card {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
}

/* Button styles - новые цвета и современные эффекты */
.btn-primary {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #1e4a8a;
  border-color: #1e4a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

.btn-outline-primary {
  color: #2c5aa0;
  border-color: #2c5aa0;
  background: transparent;
  transition: all 0.3s ease;
}

.btn-outline-primary:hover {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
  background: transparent;
  transition: all 0.3s ease;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

/* Table styles */
.table-card-v2 {
  overflow: hidden;
}

.orders-table-v2 {
  width: 100%;
  margin-bottom: 0;
  font-size: 0.85rem;
  /* Smaller font size */
  border-collapse: collapse;
  table-layout: fixed;
}

.orders-table-v2 thead {
  background-color: #f8f9fa;
}

.orders-table-v2 th,
.orders-table-v2 td {
  border: 1px solid #dee2e6;
  padding: 0.6rem 0.8rem;
  /* Reduced padding */
  vertical-align: middle;
}

.orders-table-v2 th {
  font-weight: 600;
  color: #2c3e50;
  border-top: none;
  border-bottom: 2px solid #2c5aa0;
  background: #f8f9fa;
  white-space: nowrap;
}

/* Adjust column widths for Product Index table */
.orders-table-v2 th:nth-child(1),
/* Checkbox */
.orders-table-v2 td:nth-child(1) {
  width: 50px;
  text-align: center;
}

.orders-table-v2 th:nth-child(2),
/* Назва виробу */
.orders-table-v2 td:nth-child(2) {
  width: 25%;
}

.orders-table-v2 th:nth-child(3),
/* Деталі */
.orders-table-v2 td:nth-child(3) {
  width: 55%;
}

.orders-table-v2 th:nth-child(4),
/* Дії */
.orders-table-v2 td:nth-child(4) {
  width: 120px;
  text-align: center;
}

.orders-table-v2 tbody tr {
  transition: background-color 0.2s ease;
}

.orders-table-v2 tbody tr:nth-of-type(odd) {
  background-color: white;
}

.orders-table-v2 tbody tr:nth-of-type(even) {
  background-color: #f8f9fa;
}

.orders-table-v2 tbody tr:hover {
  background-color: rgba(44, 90, 160, 0.05);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.product-list-v2 {
  font-style: italic;
  color: #2c5aa0;
}

.empty-state-v2 {
  color: #2c5aa0;
}

.empty-state-v2 i {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #ced4da;
}

.table-card-v2 .card-footer {
  background-color: white;
  border-top: 1px solid #dee2e6;
  padding: 1rem;
}
</style>